// Public surface of the patient outreach feature (PR 1).
//
// The Patients page mounts the card, one line, for staff on a practice with the
// collections feature:
//
//   import { OutreachTab } from '../outreach';
//   <OutreachTab practiceId={practiceId} patientId={patientId} />
//
// The card does not gate itself on the role or the feature: the page that mounts it
// does, so the client role never fetches an outreach endpoint.

export { default } from "./OutreachTab";
export { default as OutreachTab } from "./OutreachTab";
export { default as TemplatesTab } from "./TemplatesTab";
// The SMS number Atlas texts from: the shared one (Admin → Outreach) and a
// practice's override (Practice Details → Integrations).
export { default as SmsNumberCard } from "./SmsNumberCard";
export { default as SharedSmsNumberTab } from "./SharedSmsNumberTab";

// The feature key on the capabilities gate that turns outreach on. Outreach rides
// collections in PR 1; a key of its own is a later decision.
export const feature = "collections";
